define('plugin/contact-widget/controller/ContactWidgetController',['require','lib/controller/BaseController','plugin/contact-widget/view/ContactWidgetIndexView','plugin/contact-widget/model/ContactWidgetModel','model/CompanyModel'],function (require) {

    var BaseController = require('lib/controller/BaseController');
    var ContactWidgetIndexView = require('plugin/contact-widget/view/ContactWidgetIndexView');
    var ContactWidgetModel = require('plugin/contact-widget/model/ContactWidgetModel');
    var CompanyModel = require('model/CompanyModel');

    return BaseController.extend({

        _companyModel: null,

        index: function() {
            this.isSending = false;
            this.model = new ContactWidgetModel();

            if (!this._companyModel) {
                this._companyModel = new CompanyModel();
                this._companyModel.fetch();
            }

            this.listenTo(this.model, 'invalid', function () {
                this.isSending = false;
            });

            var indexView = new ContactWidgetIndexView({
                model: this.model,
                companyModel: this._companyModel
            });

            this.getMainLayout().getContentRegion().show(indexView);

            this.listenTo(indexView, 'sendMessage', this.onSendMessage);
        },

        onSendMessage: function(data) {
            if (!this.isSending) {
                this.isSending = true;

                var instance = this;
                this.model.save(null, {
                    'success': function() {
                        data.model.clear();
                        data.view.setSuccessMessage(Locale.getNonEscape('contact_message_add_success'));
                        data.view.render();

                        instance.isSending = false;
                    },
                    'error': function() {
                        instance.isSending = false;
                    }
                });
            }
        }

    });

});

